// Servisni sloj
import { FleetVehicleDriverRow } from "services/api/fleet/vehicles/drivers/types";

// UI
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

// Prikaz isprava dijeli se s pretragom vozača — isti podatak se ne crta na dva načina.
import {
  getDriverInitials,
  renderDriverDocument,
} from "../../../VehicleDriverSearchPage/components/VehicleDriverSearchResults/consts";

/**
 * Vozači na kartici vozila. Kolone su iste kao u pretrazi vozača, bez vozila (kartica je
 * već na jednom vozilu) i bez akcija — one stoje u zaglavlju widgeta.
 */
export const FLEET_VEHICLE_DRIVER_SEARCH_COLUMNS = (
  t: (key: string) => string
): Column[] => [
  {
    title: "",
    key: "driver_icon",
    alwaysVisible: true,
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleDriverRow) => (
      <TableIcon
        imageUrl={row.contact?.pictures?.[0]?.url ?? null}
        initials={getDriverInitials(row.name)}
      />
    ),
  },
  {
    title: "admin.fleet.vehicle.driver.search.contact",
    key: "driver_name",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleDriverRow) => (
      <div>
        <div className="text-md font-medium text-slate-900 truncate">
          {row.name ?? "-"}
        </div>
        {/* Iza vozača je korisnik aplikacije ili kontakt iz imenika. */}
        <div className="text-xs text-slate-500">
          {row.userId ? "Korisnik aplikacije" : "Kontakt"}
        </div>
      </div>
    ),
  },
  {
    title: "admin.fleet.vehicle.driver.search.driverslicence",
    key: "driver_licence",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleDriverRow) =>
      renderDriverDocument(row.driversLicenceNumber, row.driversLicenceExpiry),
  },
  {
    title: "admin.fleet.vehicle.driver.search.identitycard",
    key: "driver_identity_card",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleDriverRow) =>
      renderDriverDocument(row.identityCardNumber, row.identityCardExpiry),
  },
  {
    title: "admin.fleet.vehicle.driver.search.passport",
    key: "driver_passport",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleDriverRow) =>
      renderDriverDocument(row.passportNumber, row.passportExpiry),
  },
];
